import { Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GenericMenuItemsStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colors.menuBackground,
  width: '100%',
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.colors.iconsOnMenuBackground,
}));
